"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const async_dropdown_1 = __importStar(require("./async-dropdown"));
const filterFunc = (option, inputValue) => ((option.label || '').toLowerCase().includes(inputValue.toLowerCase()));
const AsyncStaticListSelector = ({ options, ...otherProps }) => {
    const asyncFunc = (0, react_1.useCallback)((inputValue) => {
        const filteredValues = options.map((currOption) => {
            if (currOption.options) {
                return {
                    ...currOption,
                    options: currOption.options.filter((option) => filterFunc(option, inputValue)),
                };
            }
            return filterFunc(currOption, inputValue) ? currOption : null;
        }).filter((n) => !!n);
        return new Promise((resolve) => {
            resolve(filteredValues);
        });
    }, [options]);
    return react_1.default.createElement(async_dropdown_1.default, { ...otherProps, asyncFunc: asyncFunc });
};
AsyncStaticListSelector.defaultProps = {
    ...async_dropdown_1.default.defaultProps,
};
AsyncStaticListSelector.propTypes = {
    options: prop_types_1.default.array.isRequired,
    ...async_dropdown_1.AsyncDropdownBasicProps,
};
exports.default = AsyncStaticListSelector;
//# sourceMappingURL=async-static-list-selector.js.map